export { EmbeddedVideoAndTextSideBySide } from '@/components/common/EmbeddedVideoAndTextSideBySide/EmbeddedVideoAndTextSideBySide';
